import { QuickActionButton } from 'base-components';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'lingui-react';

import messages from './messages';
import withConnectedData from './Container';

const BUTTON_ID = 'ADD_NOTE';

export function AddNoteButton({ handleActionBarItemClick }) {
  return (
    <QuickActionButton onClick={() => handleActionBarItemClick({ buttonId: BUTTON_ID })}>
      <QuickActionButton.Icon modifiers={['left']} name="envelope-o" />
      <QuickActionButton.Text>
        <Trans id={messages.title} />
      </QuickActionButton.Text>
    </QuickActionButton>
  );
}

AddNoteButton.propTypes = {
  handleActionBarItemClick: PropTypes.func.isRequired,
};

export default withConnectedData(AddNoteButton);



// WEBPACK FOOTER //
// ./compositions/AddNoteButton/index.js